/**
 * Observación meteorológica puntual (para un par coordenadas) provista por
 * Open-Meteo. Es el dato que alimenta el popup de consulta libre sobre el mapa:
 * "¿qué tiempo hace en este punto?", independientemente de que caiga o no
 * dentro de una zona de alerta SENAMHI.
 *
 * Todos los valores son escalares simples y pueden venir en `null` cuando el
 * modelo no resuelve ese punto o esa variable.
 */
export class PointWeatherEntity {
  constructor(
    /** Longitud consultada (WGS84). */
    public readonly longitude: number,
    /** Latitud consultada (WGS84). */
    public readonly latitude: number,
    /** Elevación del punto (m s. n. m.). */
    public readonly elevation: number | null,
    /** Zona horaria IANA resuelta por Open-Meteo (p. ej. "America/Lima"). */
    public readonly timezone: string | null,
    /** Instante local ISO de la observación actual. */
    public readonly observedAt: string | null,
    /** true = de día en el punto. */
    public readonly isDay: boolean | null,
    /** Temperatura actual a 2 m (°C). */
    public readonly temperature: number | null,
    /** Temperatura aparente / sensación térmica (°C). */
    public readonly apparentTemperature: number | null,
    /** Humedad relativa a 2 m (%). */
    public readonly humidity: number | null,
    /** Precipitación de la hora actual (mm). */
    public readonly precipitation: number | null,
    /** Código WMO del estado del cielo (0 = despejado, 95 = tormenta…). */
    public readonly weatherCode: number | null,
    /** Nubosidad (%). */
    public readonly cloudCover: number | null,
    /** Presión reducida a nivel del mar (hPa). */
    public readonly pressure: number | null,
    /** Velocidad del viento a 10 m (km/h). */
    public readonly windSpeed: number | null,
    /** Dirección del viento (grados, 0 = norte). */
    public readonly windDirection: number | null,
    /** Ráfaga máxima de viento (km/h). */
    public readonly windGusts: number | null,
    /** Índice UV actual. */
    public readonly uvIndex: number | null,
    /** Temperatura máxima prevista del día (°C). */
    public readonly temperatureMax: number | null,
    /** Temperatura mínima prevista del día (°C). */
    public readonly temperatureMin: number | null,
    /** Probabilidad máxima de precipitación del día (%). */
    public readonly precipitationProbabilityMax: number | null,
    /** Hora local ISO del amanecer. */
    public readonly sunrise: string | null,
    /** Hora local ISO del atardecer. */
    public readonly sunset: string | null,
    /** Departamento que contiene la coordenada (SAC/MIDAGRI); null si no cae en Perú. */
    public readonly department: string | null,
    /** Provincia que contiene la coordenada (SAC/MIDAGRI); null si no cae en Perú. */
    public readonly province: string | null,
  ) {}
}
